/**
 * Renders a single horizontal progress bar showing the user's position
 * in the quiz funnel. Mounted by the orchestrator only when
 * config.settings.progressBar is true.
 */

export function renderProgressBar(container: HTMLElement, currentIndex: number, total: number): void {
  container.replaceChildren();
  if (total <= 0) return;

  const wrap = document.createElement('div');
  wrap.style.width = '100%';
  wrap.style.maxWidth = '32rem';
  wrap.style.margin = '0 auto 1.5rem';

  const track = document.createElement('div');
  track.style.height = '6px';
  track.style.background = 'hsl(0, 0%, 92%)';
  track.style.borderRadius = '999px';
  track.style.overflow = 'hidden';
  track.setAttribute('role', 'progressbar');
  track.setAttribute('aria-valuenow', String(Math.min(currentIndex + 1, total)));
  track.setAttribute('aria-valuemin', '0');
  track.setAttribute('aria-valuemax', String(total));

  const fill = document.createElement('div');
  const pct = Math.min(100, Math.max(0, ((currentIndex + 1) / total) * 100));
  fill.style.width = `${pct}%`;
  fill.style.height = '100%';
  fill.style.background = 'var(--quiz-primary)';
  fill.style.transition = 'width 240ms ease';

  track.appendChild(fill);
  wrap.appendChild(track);
  container.appendChild(wrap);
}
